import { render } from "./DialogBGColorList.vue?vue&type=template&id=1d27d4d8"
import script from "./DialogBGColorList.vue?vue&type=script&lang=js"
export * from "./DialogBGColorList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__